import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoginState } from './login.reducer';

export const loginStateKey = 'login';

export const selectLoginState = createFeatureSelector(loginStateKey);

export const selectLoginIdToken = createSelector(
  selectLoginState,
  (loginState: LoginState) => loginState.idToken
);

export const selectLoginIsLoggedIn = createSelector(
  selectLoginState,
  (loginState: LoginState) => loginState.loggedIn
);

export const selectLoginLoggedUser = createSelector(
  selectLoginState,
  (loginState: LoginState) => loginState.loggedUser
);

export const selectLoggedUserAccess = createSelector(
  selectLoginState,
  (loginState: LoginState) => loginState.userAccess
);

export const selectUserAssociations = createSelector(
  selectLoginState,
  (loginState: LoginState) => loginState.userAssociations
);

export const selectCurrentAssociation = createSelector(
  selectLoginState,
  (loginState: LoginState) => loginState.currentAssociation
);

export const selectLoadingLogin = createSelector(
  selectLoginState,
  (loginState: LoginState) => loginState.load
);
